import {Injectable} from '@angular/core';
import {map, Observable, of, shareReplay, switchMap} from 'rxjs';
import * as userSettings from '../../user-settings/selectors/user-settings';
import {select, Store} from '@ngrx/store';
import {ApplicationState} from '../../store/application-store';
import {MojoWellKnownNames} from '../constants/mojo-well-known-names';
import {SystemConfigurationService} from '../../admin/services/system-configuration.service';
import {getDefaultApplicationDisplayName} from '@product/services/default-product-name';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private store: Store<ApplicationState>,
    private systemConfigService: SystemConfigurationService) { }

  currentProductTitle(title: string = null, product: string = null): Observable<string> {
    return this.store.pipe(select(userSettings.getCurrentProduct)).pipe(
      switchMap(actualProduct => {
        const productToUse = product || actualProduct;
        const defaultAppName = getDefaultApplicationDisplayName(productToUse);
        if (productToUse === MojoWellKnownNames.Products.MojoDashboard) {
          return of(title ? `${title} - ${defaultAppName}` : defaultAppName);
        }

        const getGeneralInformation = this.systemConfigService.getGeneralInformation(productToUse);
        return getGeneralInformation.pipe(
            map(config => {
              const appName = config.applicationName && config.applicationName.trim() !== ''
                ? config.applicationName
                : defaultAppName;
              return title ? `${title} - ${appName}` : appName;
            })
          );
      }),
      shareReplay(),
    );
  }
}
